// extracted by mini-css-extract-plugin
export default {"monogram":"Monogram-module__monogram--MgMG7"};